<h1 mat-dialog-title class="edit-form-title">Send Receipt By Email</h1>

<mat-dialog-content class="edit-form-content">
  <form class="edit-form" [formGroup]="editForm">
    <div class="content-container">
      <mat-form-field class="user-input password">
        <mat-label>Order Id</mat-label>
        <input matInput type="text" formControlName="order_id" maxlength="50" readonly />
      </mat-form-field>

      <mat-form-field class="user-input confirm_password">
        <mat-label>Total Amount</mat-label>
        <input matInput type="text" formControlName="total_amount_paid" maxlength="50" readonly />
      </mat-form-field>

      <mat-form-field class="user-input confirm_password">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" maxlength="50" />
        <mat-error *ngIf="editForm.controls['email'].hasError('required')">
          Email is required
        </mat-error>
        <mat-error *ngIf="editForm.controls['email'].hasError('email')">
          Please enter a valid email address
        </mat-error>
      </mat-form-field>
    </div>

    <mat-dialog-actions align="end" class="footer">
      <button mat-raised-button color="primary"
      [disabled]="isSending"
      (click)="sendEmail()">
<span *ngIf="isSending" class="loader"></span>
{{ isSending ? 'Sending...' : 'Send' }}
</button>


      <button mat-button type="button" (click)="cancel()">Cancel</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>